export default "__VITE_ASSET__097f5c88__"